import { Injectable } from '@angular/core';
import { DataService } from '../../shared/services/data.service';
import { BaseService } from '../../shared/services/base.service';
import { InspectionConstantsService } from './inspection-constants.service';

@Injectable()
export class InspectionService {
  currentInspectionId: number;
  public updatedInspectionData: any;//Pritesh
  public oldActionData: any;//Pritesh

  constructor(private dataService: DataService,
    private baseService: BaseService) { }

  getAllInspectionIds() {
    return JSON.parse(this.baseService.getItemFromSession('inspectionIds'));
  }
  setAllInspectionIds(inspectionIds) {
    this.baseService.setItemInSession('inspectionIds', JSON.stringify(inspectionIds));
  }
  setcurrentInspectionRequestId(inspectionId) {
    this.currentInspectionId = inspectionId;
  }
  getcurrentInspectionRequestId() {
    return this.currentInspectionId;
  }
  public setUpdatedInspectionData(data) {
    this.updatedInspectionData = data;
  }
  public getUpdatedInspectionData() {
    return this.updatedInspectionData;
  }

  //BOC Pritesh
  public setoldActionData(data) {
    this.oldActionData = data;
  }
  public getoldActionData() {
    return this.oldActionData;
  }
  //EOC Pritesh

  /**
      * Function to Save Company Details request.
      * @param model - Model contain Status
      * @param response - response of request.
      */
  saveInspection(model, callbackMethod) {
    this.dataService.post(InspectionConstantsService.APIURL.SaveInspection, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getInspectionData(model, callbackMethod) {
    this.dataService.post(InspectionConstantsService.APIURL.GetInspectionData, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  getInspectionDataByInspectionRequestId(model, callbackMethod) {
    this.dataService.post(InspectionConstantsService.APIURL.GetInspectionDataByInspectionRequestId, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
  exportToExcelInspectionData(model, callbackMethod) {
    this.dataService.post(InspectionConstantsService.APIURL.ExportToExcelInspectionData, model)
      .subscribe(response => {
        callbackMethod(response);
      });
  }
}